export const ENV = {
  get currentConfig () {
    const publicObj = useRuntimeConfig().public;
    const domain = publicObj.domain;
    let locale = publicObj.lang;
    const apiHost = `${domain[locale]}/api`;
    const config = {
      version: publicObj.version,
      packageName: publicObj.packageName,
      apiHost,
      mediaCDN: publicObj.mediaCDN,
      googleSignInClientId: publicObj.googleSignInClientId,
      firebaseConfig: publicObj.firebaseConfig,
      domain,
      lang: publicObj.lang,
      gaid: publicObj.gaid,
    };
    return config;
  },
  get isDev() {
    return useRuntimeConfig().public.env == "dev";
  },
  get isUat() {
    return useRuntimeConfig().public.env == "uat";
  },
  get isProd() {
    return !this.isDev && !this.isUat;
  },
};
